import { connect } from 'react-redux'
import {
  compose, lifecycle, withState, withHandlers,
} from 'recompose'
import { bindActionCreators } from 'redux'
import { updateSiteConfiguration, updateSiteConfigs } from 'actions/Site'
import { fetchReviews, deleteReview } from 'actions/Reviews'
import ReviewView from 'components/pages/webManagement/reviews/List'
import { message } from 'antd'

export function mapStateToProps(state) {
  const { currentUser } = state.root.auth

  return {
    currentUser,
  }
}

const mapDispatchToProps = dispatch => ({
  updateSiteConfiguration: bindActionCreators(updateSiteConfiguration, dispatch),
  updateSiteConfigs: bindActionCreators(updateSiteConfigs, dispatch),
  fetchReviews: bindActionCreators(fetchReviews, dispatch),
  deleteReview: bindActionCreators(deleteReview, dispatch),
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('reviewList', 'setReviewList', {
    data: [],
    meta: {},
    isFetching: true,
  }),
  withHandlers({
    getReviewList: props => () => {
      props.fetchReviews()
        .then((result) => {
          props.setReviewList({
            data: result.data,
            meta: result.meta,
            isFetching: false,
          })
        })
        .catch((error) => {
          props.setReviewList({
            data: [],
            meta: {},
            isFetching: false,
          })
          message.error(error.message)
        })
    },
  }),
  withHandlers({
    handleDelete: props => (id) => {
      props.deleteReview(id)
        .then(() => {
          props.getReviewList()
        })
        .catch((error) => { message.error(error) })
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.updateSiteConfiguration('breadList', ['Home', 'Web Management', 'Reviews'])
      this.props.updateSiteConfigs({
        titlePage: 'Review List',
        activePage: 'web-management/reviews',
        activeSubPage: 'web-management',
      })
      this.props.getReviewList()
    },
  }),
)(ReviewView)
